module.exports = __webpack_public_path__ + "img/logo.bb4b6ea0.png";